import API from '..';
const ENTITY = 'chats/credit';

export const initChat = (creditId) => API.post(`/api/v1/${ENTITY}/${creditId}`);
export const fetchMessages = (chatId) => API.get(`/api/v1/${ENTITY}/${chatId}`);
export const sendMessage = (chatId, data) =>
    API.post(`/api/v1/${ENTITY}/${chatId}/message/`, data);
